import React from "react";
import { L10n, L10nId } from "@fidget/common/i18n";
import { DashboardView } from "../containers/dashboard/views/DashboardView";
import { Path } from "../models/router";
import { NavButton } from "./settings/navButton";

interface Props {
  currentView: DashboardView;
  desiredView: DashboardView;
  l10nId: L10nId;
  linkTo: Path;
}

export const NavigationButton = ({ currentView, desiredView, l10nId, linkTo }: Props) => {
  return (
    <NavButton isActive={currentView === desiredView} linkTo={linkTo}>
      <L10n id={l10nId} />
    </NavButton>
  );
};
